import axios from 'axios';
import { componentSubTypes, componentTypes, ListTemplatesQsp, RenderTemplateAccepts, RenderTemplateContentTypes, } from './schema.js';
import { ProofMethod } from '@pok/open-badge-sdk';
export * from './schema.js';
export * from './utils.js';
export const storeTemplate = async (apiRoot, input, authToken) => axios
    .post(`${apiRoot}/templates`, input, { headers: { Authorization: authToken.value() } })
    .then((response) => response.data);
export const updateTemplate = async (apiRoot, input, authToken) => axios
    .put(`${apiRoot}/templates/${input.id}`, input, { headers: { Authorization: authToken.value() } })
    .then((response) => response.data);
export const renderTemplate = async (apiRoot, input, output, authToken) => axios
    .post(`${apiRoot}/templates/render`, input, {
    headers: {
        'Content-Type': input.source.type,
        Authorization: authToken.value(),
        Accept: output.accept,
    },
})
    .then((response) => output.parse(response.data));
export const getTemplateById = async (apiRoot, id, authToken) => axios
    .get(`${apiRoot}/templates/${id}/id`, { headers: { Authorization: authToken.value() } })
    .then((response) => response.data)
    .catch(async (error) => (error?.response?.status === 404 ? undefined : Promise.reject(error)));
export const deleteTemplateById = async (apiRoot, id, authToken) => axios
    .delete(`${apiRoot}/templates/${id}`, { headers: { Authorization: authToken.value() } })
    .then((response) => response.data);
export const listFonts = async (apiRoot, //
authToken) => axios
    .get(`${apiRoot}/fonts`, { headers: { Authorization: authToken.value() } }) //
    .then((response) => response.data);
export const listEnabledFonts = async (apiRoot, authToken) => axios
    .get(`${apiRoot}/fonts?enabled=true`, { headers: { Authorization: authToken.value() } })
    .then((response) => response.data);
export const listTemplates = async (apiRoot, input, authToken) => axios
    .get(`${apiRoot}/templates`, {
    params: {
        [ListTemplatesQsp.owner]: input.owner,
        [ListTemplatesQsp.type]: input.type,
        [ListTemplatesQsp.locale]: input.locale,
        [ListTemplatesQsp.tagId]: input.tagId,
        [ListTemplatesQsp.orderBy]: input.orderBy,
        [ListTemplatesQsp.orderAscending]: input.orderAscending,
    },
    headers: { Authorization: authToken.value() },
})
    .then((r) => r.data);
export const uploadTemplateAttachment = async (apiRoot, organization, template, file, authToken) => axios
    .post(`${apiRoot}/attachments/${organization}/${template}`, {}, { headers: { Authorization: authToken.value() } })
    .then((r) => r.data)
    .then(async (url) => axios.put(url, file).then((response) => response.headers['x-amz-meta-cid']));
export function isTextItem(item) {
    return item.type === 'text';
}
export const templateTypeSettings = {
    badge: {
        viewPortSize: {
            width: 800,
            height: 800,
        },
    },
    certificate: {
        viewPortSize: {
            width: 800,
            height: 619,
        },
    },
};
export const templateAvailablePageFormats = [
    {
        id: 'letter',
        name: 'design.format_page.paper_size_name_letter',
        measures: '27.94 x 21.5 cm',
        size: { width: 1648, height: 1276 },
    },
    {
        id: 'legal',
        name: 'design.format_page.paper_size_name_legal',
        measures: '35.56 x 21.59 cm',
        size: { width: 2102, height: 1276 },
    },
    {
        id: 'tabloid',
        name: 'design.format_page.paper_size_name_tabloid',
        measures: '27.9 x 43.2 cm',
        size: { width: 2551, height: 1648 },
    },
    {
        id: 'a3',
        name: 'design.format_page.paper_size_name_a3',
        measures: '42.03 x 29.70 cm',
        size: { width: 2480, height: 1754 },
    },
    {
        id: 'a4',
        name: 'design.format_page.paper_size_name_a4',
        measures: '29.70 x 20.99 cm',
        size: { width: 1754, height: 1240 },
    },
    {
        id: 'a5',
        name: 'design.format_page.paper_size_name_a5',
        measures: '14.80 x 21.00 cm',
        size: { width: 1240, height: 874 },
    },
];
export const outputAsTemplateDefinition = {
    accept: RenderTemplateAccepts.TEMPLATE,
    parse: (data) => data,
};
export const CUSTOM_ATTRIBUTE_DELIMITER = ':';
export const CUSTOM_PREFIX = `custom${CUSTOM_ATTRIBUTE_DELIMITER}`;
export const DESCRIPTION = 'description';
export const REQUIREMENTS = 'requirements';
export const APTITUDES = 'aptitudes';
export const ATTACHMENTS = 'attachments';
export const GENERAL_PERSONALIZED_INFORMATION = 'general_personalized_information';
export const OB_COMPLIANT = 'ob_quality_info_enabled';
export const OB_PROOF_METHOD = 'ob_proof_method';
export const ACHIEVEMENT_NAME_SOURCE = 'achievement_name_source';
export const ACHIEVEMENT_NAME_OTHER_SOURCE = 'achievement_name_other_source';
export const EDTECH_COMPLIANT = 'edtech_info_enabled';
export const EDTECH_FRAMEWORK_ALIGNMENT = 'edtech_framework_alignment';
export const EDTECH_ASSESSMENT_TYPE = 'edtech_assessment_type';
export const EDTECH_ASSESSMENT_DESCRIPTION = 'edtech_assessment_description';
export const EDTECH_ASSESSMENT_OUTPUT = 'edtech_assessment_output';
export const EDTECH_ASSESSMENT_HAS_GROUP_PARTICIPATION = 'edtech_assessment_has_group_participation';
export const EDTECH_ASSESSMENT_HAS_GROUP_EVALUATION = 'edtech_assessment_has_group_evaluation';
export const EDTECH_ISSUER_NAME = 'edtech_issuer_name';
export const EDTECH_ISSUER_ADDRESS = 'edtech_issuer_address';
export const EDTECH_ISSUER_URL = 'edtech_issuer_url';
export const EDTECH_ISSUER_CONTACT_INSTRUCTIONS = 'edtech_issuer_contact_instructions';
export const EDTECH_CUSTOM_RESULT = `${CUSTOM_PREFIX}edtech:result`;
export const mapToAdditionalInfo = (templateDefinition, gatewayUrlBuilder, userInputParams = []) => {
    const info = templateDefinition?.info || [];
    const findIn = (key) => info.find((x) => x.key === key)?.value;
    const findInTemplateParams = (templateParams, paramNameToSearch) => templateParams.find((m) => m.name === paramNameToSearch)?.value;
    const customInfo1 = findIn(GENERAL_PERSONALIZED_INFORMATION)?.map((x) => ({
        key: x.key,
        value: toTextMultiline(x.value),
        name: x?.name,
        text: x?.text,
    })) || [];
    const customInfo2 = info
        ?.filter((x) => x.key)
        .filter((i) => (i.key?.startsWith(CUSTOM_PREFIX) && i.key !== EDTECH_CUSTOM_RESULT) || false)
        .map((x) => {
        return {
            key: x.key,
            text: x.value,
            value: toTextMultiline(findInTemplateParams(templateDefinition.params, x.key)),
        };
    }) || [];
    const hasOpenBadgeQualityInfo = findIn(OB_COMPLIANT) || false;
    const hasEdtechInfo = findIn(EDTECH_COMPLIANT) || false;
    const retrieveCustomSource = () => {
        const nameSource = findIn(ACHIEVEMENT_NAME_SOURCE);
        return nameSource === ACHIEVEMENT_NAME_SOURCE_OTHER_OPTION
            ? findIn(ACHIEVEMENT_NAME_OTHER_SOURCE)
            : userInputParams.find((entry) => entry.key === nameSource)?.value || '';
    };
    const achievementName = hasOpenBadgeQualityInfo
        ? retrieveCustomSource()
        : userInputParams.find((entry) => entry.key === DEFAULT_INPUT_KEY.TITLE)?.value || '';
    const description = toTextMultiline(findIn(DESCRIPTION));
    const requirements = toTextMultiline(findIn(REQUIREMENTS));
    const aptitudes = findIn(APTITUDES) || [];
    const edtechInfo = hasEdtechInfo
        ? {
            criteria: requirements.join(' '),
            achievementType: templateDefinition.templateType === 'badge' ? 'Badge' : 'Certificate',
            frameworkAlignment: findIn(EDTECH_FRAMEWORK_ALIGNMENT),
            assessmentType: resolveAssessmentType(findIn(EDTECH_ASSESSMENT_TYPE)),
            assessmentDescription: findIn(EDTECH_ASSESSMENT_DESCRIPTION),
            assessmentOutput: findIn(EDTECH_ASSESSMENT_OUTPUT),
            assessmentHasGroupParticipation: findIn(EDTECH_ASSESSMENT_HAS_GROUP_PARTICIPATION),
            assessmentHasGroupEvaluation: findIn(EDTECH_ASSESSMENT_HAS_GROUP_EVALUATION),
            issuerProfileName: findIn(EDTECH_ISSUER_NAME),
            issuerProfileContactInstructions: findIn(EDTECH_ISSUER_CONTACT_INSTRUCTIONS),
            issuerProfileUrl: findIn(EDTECH_ISSUER_URL),
            issuerProfileStreetAddress: findIn(EDTECH_ISSUER_ADDRESS),
            skills: aptitudes,
            result: userInputParams.find((entry) => entry.key === EDTECH_CUSTOM_RESULT)?.value || '',
        }
        : undefined;
    return {
        description: description,
        requirements: requirements,
        aptitudes: aptitudes,
        customInfo: [...customInfo1, ...customInfo2],
        attachments: findIn(ATTACHMENTS)?.map((x) => ({
            url: gatewayUrlBuilder(x.value),
            name: x.name,
        })) || [],
        obQualityInfo: {
            achievementName: achievementName,
            criteria: requirements.join(' '),
            description: description.join(' '),
        },
        edtechInfo: edtechInfo,
        proofMethod: findIn(OB_PROOF_METHOD) || ProofMethod.LINKED_DATA,
    };
};
const toTextMultiline = (text) => (text ? text.split('\n') : []);
export const ACHIEVEMENT_NAME_SOURCE_OTHER_OPTION = '###other###';
export const getTemplateDefinitionFromIpfs = async (ipfsGatewayResourceUrl) => axios.get(ipfsGatewayResourceUrl).then((response) => response.data);
export var DEFAULT_INPUT_KEY;
(function (DEFAULT_INPUT_KEY) {
    DEFAULT_INPUT_KEY["TITLE"] = "title";
    DEFAULT_INPUT_KEY["INSTITUTION"] = "institution";
    DEFAULT_INPUT_KEY["DATE"] = "date";
    DEFAULT_INPUT_KEY["ACHIEVER"] = "achiever";
    DEFAULT_INPUT_KEY["QR_CODE"] = "qrcode";
    DEFAULT_INPUT_KEY["LOCALE"] = "locale";
})(DEFAULT_INPUT_KEY || (DEFAULT_INPUT_KEY = {}));
export var DEFAULT_LABEL_INPUT_KEY;
(function (DEFAULT_LABEL_INPUT_KEY) {
    DEFAULT_LABEL_INPUT_KEY["PROUDLY"] = "label:proudly";
    DEFAULT_LABEL_INPUT_KEY["TITLE"] = "label:title";
    DEFAULT_LABEL_INPUT_KEY["DATE"] = "label:date";
})(DEFAULT_LABEL_INPUT_KEY || (DEFAULT_LABEL_INPUT_KEY = {}));
export const buildNormalizedUserInputParams = (userInputValues, params) => {
    const buildEntryFromParams = (key, params) => {
        return {
            key: key,
            value: params.find((param) => param.name === key)?.value || '',
        };
    };
    const mergedParams = [];
    mergedParams.push({ key: DEFAULT_INPUT_KEY.TITLE, value: userInputValues.title });
    mergedParams.push({ key: DEFAULT_INPUT_KEY.INSTITUTION, value: userInputValues.institution });
    mergedParams.push({ key: DEFAULT_INPUT_KEY.DATE, value: userInputValues.date.toString() });
    mergedParams.push({
        key: DEFAULT_INPUT_KEY.ACHIEVER,
        value: userInputValues.achiever,
    });
    mergedParams.push(buildEntryFromParams(DEFAULT_LABEL_INPUT_KEY.PROUDLY, params));
    mergedParams.push(buildEntryFromParams(DEFAULT_LABEL_INPUT_KEY.TITLE, params));
    mergedParams.push(buildEntryFromParams(DEFAULT_LABEL_INPUT_KEY.DATE, params));
    mergedParams.push(...Object.keys(userInputValues.customAttributes).map((key) => ({
        key: key,
        value: userInputValues.customAttributes[key],
    })));
    const customLabels = params
        .filter((x) => {
        const currentParamKeys = mergedParams
            .map((y) => y.key)
            .concat([DEFAULT_INPUT_KEY.LOCALE, DEFAULT_INPUT_KEY.QR_CODE]);
        return !currentParamKeys.includes(x.name);
    })
        .map((x) => ({ key: x.name, value: x.value }));
    return mergedParams.concat(customLabels);
};
export const outputAsImageDataUri = {
    accept: RenderTemplateAccepts.IMAGE_DATA_URI,
    parse: (data) => data,
};
export const outputAsImageUrl = {
    accept: RenderTemplateAccepts.IMAGE_URL,
    parse: (data) => data,
};
const signatureCondition = (item, signatureId) => item.type === componentTypes.image && item.subType === componentSubTypes.signature && item.group === signatureId;
export const findSignatureOnTemplateOrFail = (definition, signatureId) => {
    const found = definition.template.find((item) => signatureCondition(item, signatureId));
    if (found === undefined)
        throw new SignatureNotFound(signatureId);
    return found;
};
export const interpolateSignatureOnTemplate = (definition, newImageBase64, signatureId) => {
    findSignatureOnTemplateOrFail(definition, signatureId);
    return {
        ...definition,
        template: definition.template.map((item) => ({
            ...item,
            value: signatureCondition(item, signatureId) ? newImageBase64 : item.value,
        })),
    };
};
export class SignatureNotFound extends Error {
    constructor(id) {
        super(`no item found on template definition for signature: ${id}`);
    }
}
export const fontCidFromName = (fontName, definition) => {
    const found = definition.template.find((item) => item.type === 'font' && item.name === fontName);
    if (!found)
        throw new Error(`font name: ${fontName} not found for template definition`);
    return found.value;
};
export const resolveAssessmentType = (selectedValue) => {
    switch (selectedValue) {
        case 'PERFORMANCE':
            return 'Performance';
        case 'OBJECT':
            return 'Artifact';
        default:
            return 'Exam';
    }
};
export class SdkTemplateManager {
    templateManagerApiRoot;
    tokenStore;
    constructor(templateManagerApiRoot, tokenStore) {
        this.templateManagerApiRoot = templateManagerApiRoot;
        this.tokenStore = tokenStore;
    }
    async templateById(templateId) {
        const authToken = await this.tokenStore.retrieveClientCredentials();
        return getTemplateById(this.templateManagerApiRoot, templateId, authToken);
    }
    async renderTemplate(definition, data) {
        const authToken = await this.tokenStore.retrieveClientCredentials();
        return renderTemplate(this.templateManagerApiRoot, {
            source: {
                type: RenderTemplateContentTypes.DEFINITION,
                definition: definition,
            },
            data: {
                params: {
                    institution: data.institution,
                    name: data.name,
                    title: data.title,
                    date: data.date,
                    dateFormat: data.dateFormat,
                    url: data.url,
                    customParams: data.customParams,
                    openBadgeV3Signature: data.openBadgeV3Signature,
                },
            },
        }, outputAsTemplateDefinition, authToken);
    }
}
export const customAttributeNameResolver = (attributeName) => {
    const nameAsArray = attributeName.split(CUSTOM_ATTRIBUTE_DELIMITER);
    return nameAsArray.splice(2, nameAsArray.length).join(CUSTOM_ATTRIBUTE_DELIMITER);
};
export var TemplatesOrderBy;
(function (TemplatesOrderBy) {
    TemplatesOrderBy["NAME"] = "NAME";
    TemplatesOrderBy["UPDATED_AT"] = "UPDATED_AT";
})(TemplatesOrderBy || (TemplatesOrderBy = {}));
export const createTag = async (apiRoot, input, authToken) => axios
    .post(`${apiRoot}/tags/${input.owner}`, { name: input.name }, { headers: { Authorization: authToken.value() } })
    .then((response) => response.data);
export const deleteTag = async (apiRoot, input, authToken) => axios
    .delete(`${apiRoot}/tags/${input.owner}/${input.id}`, { headers: { Authorization: authToken.value() } })
    .then(() => undefined);
export const tagTemplate = async (apiRoot, input, authToken) => axios
    .post(`${apiRoot}/tags/template/${input.template}/${input.id}`, input, {
    headers: { Authorization: authToken.value() },
})
    .then(() => undefined);
export const untagTemplate = async (apiRoot, input, authToken) => axios
    .delete(`${apiRoot}/tags/template/${input.template}/${input.id}`, {
    headers: { Authorization: authToken.value() },
})
    .then(() => undefined);
export const listTags = async (apiRoot, input, authToken) => axios
    .get(`${apiRoot}/tags/${input.owner}`, {
    params: {
        type: input.countingTemplatesBy.type,
        locale: input.countingTemplatesBy.locale,
    },
    headers: { Authorization: authToken.value() },
})
    .then((response) => response.data);
//# sourceMappingURL=index.js.map